import { render, staticRenderFns } from "./EmployeeLastDayPay.vue?vue&type=template&id=40135021&scoped=true&"
import script from "./EmployeeLastDayPay.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeeLastDayPay.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EmployeeLastDayPay.vue?vue&type=style&index=0&id=40135021&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40135021",
  null
  
)

export default component.exports